import components from './components'
import foundations from './foundations'

const defaultTheme = {
  components,
  ...foundations,
}

export default defaultTheme
